import { render, staticRenderFns } from "./VSectionTitle.vue?vue&type=template&id=670a73f8&scoped=true&"
import script from "./VSectionTitle.vue?vue&type=script&lang=js&"
export * from "./VSectionTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670a73f8",
  null
  
)

export default component.exports